<template>
    <div class="page">
        <!-- <answer-header type="back"></answer-header> -->
        <div class="test" @click="_gotoUcenter">Start</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Welcome',
    components: {answerHeader},
    data(){
        return {
        }
    },
    computed: {
        ...mapState(['lang','langMap'])
    },
    created(){
        this._fetchCookiesInfo();
    },
    methods: {
        _gotoUcenter(){
            this.$router.push(`/ucenter`);
        },
        _fetchCookiesInfo(){
            let reqData = {mobile: this.$route.query.mobile}
            if(typeof this.$route.query.mobile === 'undefined'){
                reqData = {mobile: localStorage.A_mobile}
            }
            Utils.$ajax({
                type: 'post',
                url: '/login/check',
                data: reqData,
            }).done(res=>{
                console.log(res);
                if(res.code == 0){
                    localStorage.A_uuid = res.data.uuid;
                    localStorage.A_token = res.data.token;
                    localStorage.A_mobile = res.data.mobile;
//                    location.reload();
                    if(res.data.status != 1){
                        window.location = 'http://questtomio.com/lp.php?msisdn='+res.data.mobile;
                    }
                }
                else{
                    //this.$toast(res.msg);
                    this.$router.go('http://questtomio.com/lp.php?msisdn=');
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        color: #fff;
    }
    .fz46{
        font-size: rem(46);
    }
    .test{
        position: absolute;
        top: rem(80);
        right: rem(50);
        font-family: 'Arial black';
        font-size: rem(35);
        color: #000;
        font-weight: bold;
    }

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue